/** @format */

import {format, startOfMonth, subDays, subMonths} from 'date-fns';

import {Period} from '../types';

/**
 * Медиаплан не настроен или не подходит по критериям, берём текущий период.
 */

const getCurrentPeriod = (today: Date): Period => {
  const todayDate = today.getDate();
  const yesterday = subDays(today, 1);

  // 1 число месяца → {startDate: первое число предыдущего месяца, endDate: вчера}
  if (todayDate === 1) {
    const firstOfPrev = startOfMonth(subMonths(today, 1));
    return {
      startDate: format(firstOfPrev, 'yyyy-MM-dd'),
      endDate: format(yesterday, 'yyyy-MM-dd'),
    };
  }

  const firstOfCurrent = startOfMonth(today);

  // 2 число месяца → {оба = первое число текущего месяца}
  if (todayDate === 2) {
    const day = format(firstOfCurrent, 'yyyy-MM-dd');
    return {
      startDate: day,
      endDate: day,
    };
  }

  // Стандартный кейс: {startDate: первое число текущего месяца, endDate: вчера}
  return {
    startDate: format(firstOfCurrent, 'yyyy-MM-dd'),
    endDate: format(yesterday, 'yyyy-MM-dd'),
  };
};

export {getCurrentPeriod};
